import {
    depositObligationCollateralInstruction,
    Detail,
    LendingMarket,
    Obligation,
    Reserve,
    TokenAccount
} from "@/api/models";
import {getObligation} from "@/api/provider/obligationProvider";
import {WalletAdapter} from "@/api/wallets";
import {Account, PublicKey, TransactionInstruction} from "@solana/web3.js";
import {getConnection, sendTransaction} from "@/api/context/connection";
import {withdrawMining} from "@/api/actions/utils/withdrawMining";
import {U64_MAX} from "@/api/constants/math";
import {refreshReserve} from "@/api/actions/utils/refreshReserve";
import {initObligation} from "@/api/actions/utils/initObligation";
import {Mining} from "@/api/models/state/mining";
import {getMining} from "@/api/provider/miningProvider";
import openTxDialog from "@/controller/openTxDialog";


/**
 *
 * @param depositReserveDetail
 * @param wallet
 * @param lendingMarket
 */
export async function intoObligation(
    depositReserveDetail:Detail<Reserve>,
    wallet:WalletAdapter,
    lendingMarket:Detail<LendingMarket>,
    lendingProgaramId:PublicKey,
    cTokenAccount:TokenAccount,
    mining:Detail<Mining>,
    allReserve:Detail<Reserve>[],
    obligation?:Detail<Obligation>,

){
    if (wallet.publicKey == null){
        throw new Error("Wallet need connected")
    }

    openTxDialog()
    const connection = await getConnection();

    const depositReserveAddress = depositReserveDetail.pubkey

    const signers: Account[] = [];
    const instructions: TransactionInstruction[] = [];
    const cleanupInstructions: TransactionInstruction[] = [];


    if (mining===undefined){
        const myMinings = await getMining(wallet.publicKey,lendingMarket.pubkey,lendingProgaramId)
        if (myMinings.length>0){
            mining = myMinings[0]
        }
    }
    const appendReserves: PublicKey[] = []
    if (obligation==undefined){
        const myObligations = await getObligation(wallet.publicKey,lendingMarket.pubkey,lendingProgaramId)
        if (myObligations.length>0){
            obligation = myObligations[0]
        }
    }

    let myObligationAddress:PublicKey
    if (obligation == undefined){
        myObligationAddress = await initObligation(
            connection,
            signers,
            instructions,
            cleanupInstructions,
            wallet,
            lendingMarket,
            lendingProgaramId
        )
    } else {
        myObligationAddress = obligation.pubkey
        let newDeposit = true
        obligation.info.deposits.map(deposit => {
            if (deposit.depositReserve.equals(depositReserveAddress)) {
                newDeposit = false
            }
        })
        if (newDeposit){
            if (obligation!==undefined){
                obligation.info.deposits.map(deposit2 => {
                    appendReserves.push(deposit2.depositReserve)
                })
                obligation.info.borrows.map(borrow => {
                    appendReserves.push(borrow.borrowReserve)
                })
            }
        }
        console.log("appendReserves",appendReserves);
    }
    await refreshReserve(
        connection,
        signers,
        instructions,
        cleanupInstructions,
        depositReserveDetail,
        lendingProgaramId
    )
    mining.info.miningIndices.map(async (miningIndex) => {
        if (miningIndex.reserve.equals(depositReserveDetail.pubkey)) {
            await withdrawMining(
                connection,
                signers,
                instructions,
                cleanupInstructions,
                mining.pubkey,
                cTokenAccount.pubkey,
                depositReserveDetail,
                U64_MAX,
                wallet,
                lendingMarket.pubkey,
                lendingProgaramId
            )
        }
    })

    const [lendingMarketAuthority] = await PublicKey.findProgramAddress(
        [lendingMarket.pubkey.toBuffer()],
        lendingProgaramId,
    );

    await refreshReserve(
        connection,
        signers,
        instructions,
        cleanupInstructions,
        depositReserveDetail,
        lendingProgaramId
    )
    instructions.push(
        depositObligationCollateralInstruction(
            U64_MAX,
            cTokenAccount.pubkey,
            depositReserveDetail.info.collateral.supplyPubkey,
            depositReserveAddress,
            myObligationAddress,
            lendingMarket.pubkey,
            lendingProgaramId,
            lendingMarketAuthority,
            // @FIXME: wallet must sign
            wallet.publicKey,
            wallet.publicKey,
            appendReserves
        ),
    );
    return  await sendTransaction(
        connection,
        wallet,
        instructions.concat(cleanupInstructions),
        signers,
        true,
    )
}